<div class="p-flex" #editorContainer style="min-width: 180px;">
  <p-autoComplete
    #autocompleteComponent
    [(ngModel)]="value"
    [appendTo]="editorContainer"
    [suggestions]="suggestions"
    (completeMethod)="search($event)"
    [field]="optionLabel"
    [placeholder]="fieldName"
    [minLength]="1"
    [delay]="300"
    [autoHighlight]="true"
    [multiple]="isMultiple"
    [dropdown]="false"
    [style]="{'min-width': '180px', 'max-width': '400px'}"
  >
    <ng-template let-item pTemplate="item">
      <div class="p-flex align-items-center gap-2">
        {{ item.name }} {{item.id ? ' ('+item.id+')' : ''}}
      </div>
    </ng-template>
    <ng-template let-value pTemplate="selectedItem">
      <div class="p-flex align-items-center gap-2">
        {{ value.name }} {{value.id ? ' ('+value.id+')' : ''}}
      </div>
    </ng-template>
  </p-autoComplete>

  <button
    pButton
    pRipple
    ariaLabel="Revert to Original Value"
    icon="pi pi-undo"
    class="p-mx-1 p-button-text p-button-xs p-flex-shrink-0"
    tabindex="-1"
    (click)="setOriginalValue()"
  ></button>
  <button
    pButton
    pRipple
    ariaLabel="Clear Field"
    icon="pi pi-minus"
    tabindex="-1"
    class="p-button-text p-button-danger p-button-xs p-flex-shrink-0"
    (click)="clearValue()"
  ></button>
</div> 